import intlMessageEN from '../../components/ il8n/locales/en.json';
import intlMessageTR from '../../components/ il8n/locales/tr.json';

export function getLocale() {
    const locale = navigator.language;
    switch (locale) {
        case "tr":
        case "tr-TR":
            return "tr";
        default:
            return "en"
    }
}

export function getMessages() {
    const locale = getLocale()
    switch (locale) {
        case "tr":
            return intlMessageTR;
        default:
            return intlMessageEN
    }
}


// WEBPACK FOOTER //
// ./src/components/handler/LocaleHandler.js